import { render, staticRenderFns } from "./PayType.vue?vue&type=template&id=3fc0dc8a&scoped=true&"
import script from "./PayType.vue?vue&type=script&lang=js&"
export * from "./PayType.vue?vue&type=script&lang=js&"
import style0 from "./PayType.vue?vue&type=style&index=0&id=3fc0dc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc0dc8a",
  null
  
)

export default component.exports